import { styled } from 'goober';
export var Page = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '22px',
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        backgroundColor: 'white',
        fontSize: theme.font.size,
        flexGrow: 1,
    });
});
export var PageTitle = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        marginBottom: '30px',
        '>svg:first-child': {
            width: '26px',
            height: '26px',
            marginRight: '11px',
        },
        h2: {
            margin: '0px',
            flexGrow: 1,
            fontSize: '26px',
        },
        h3: {
            margin: '0px',
            flexGrow: 1,
        },
    });
});
export var ErrorPage = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        background: ' #f6f6f6',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
    });
});
export var ErrorBox = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: '#001024',
        minHeight: '350px',
        width: '500px',
        margin: 'auto',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        h1: {
            fontSize: '120px',
            fontWeight: 'bold',
            margin: '20px',
        },
        h2: {
            fontWeight: 'bold',
        },
    });
});
